export default {
  biu: {
    id: 'biu',
    name: 'Benson Idahosa University',
    gradingSystem: {
      firstClass: 4.0,
      secondClassUpper: 3.5,
      secondClassLower: 2.5,
      thirdClass: 2.0,
      pass: 2.0
    }
  },
  bcu: {
    id: 'bcu',
    name: 'Babcock University',
    gradingSystem: {
      firstClass: 4.0,
      secondClassUpper: 3.5,
      secondClassLower: 2.5,
      thirdClass: 2.0,
      pass: 2.0
    }
  },
  cu: {
    id: 'cu',
    name: 'Covenant University',
    gradingSystem: {
      firstClass: 4.0,
      secondClassUpper: 3.5,
      secondClassLower: 2.5,
      thirdClass: 2.0,
      pass: 2.0
    }
  }
}



// WEBPACK FOOTER //
// ./src/offlineData/schools.js